import styled from 'styled-components';
import BaseCheckbox from '@deprecated-ui/common/Checkbox';
import Button from '@deprecated-ui/common/Button';
import BaseSlider from '@deprecated-ui/trading/Slider';
import color from '@deprecated-ui/_style/color';
import { Tabs as BaseTabs } from 'antd';

const { TabPane: BaseTabPane } = BaseTabs;

const TabWrapper = styled.div`
  .ant-tabs-nav-list {
    width: 100%;
  }
  .ant-tabs-nav-list {
    .ant-tabs-tab {
      width: 50%;
      text-align: center;
      font-family: var(--bold-font);

      &.ant-tabs-tab-active {
        color: ${color.mountainMeadow};
        .ant-tabs-tab-btn {
          color: ${color.mountainMeadow};
        }
      }

      .ant-tabs-tab-btn {
        width: 100%;
        color: ${color.highgray};

        :hover {
          color: ${color.highgray};
        }
      }
    }
  }

  .ant-tabs-ink-bar {
    background-color: #0bba7a !important;
  }
`;

const CustomSelect = styled.select`
  width: 100%;
  border: solid 1px ${color.gainsboro};
  height: 32px;
  padding: 0 10px;
  border-radius: 2px;

  /* Add style when disabled*/
  &:disabled {
    color: #b5b5b5;
    background: #f5f5f5;
    cursor: not-allowed;
    opacity: 0.7;
  }
`;

const TriggerPriceSelect = styled(CustomSelect)`
  min-width: 36px;
  width: 36px;
  margin-right: 0px;
  text-indent: 0;
  padding-left: 5px;
  padding-right: 16px;
`;

const AutoBuySubmitButton = styled(Button)`
  position: absolute;
  bottom: -55px;
  width: 100%;

  :disabled {
    background: #616161;
    border-color: #616161;
    color: #bcbcbc;
  }
`;

const TabPane = styled(BaseTabPane)``;

const Tabs = styled(BaseTabs)`
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${color.primary} !important;
  }

  .ant-tabs-tab-active {
    color: ${color.primary} !important;
  }
`;

const Slider = styled(BaseSlider)`
  .ant-slider-step {
    background-color: ${color.gainsboro} !important;
    height: 4px;
    top: 4px;
    z-index: 0;
    border-radius: 2px;
  }

  .ant-slider-track {
    border-radius: 2px;
    height: 4px;
    z-index: 1;
  }

  .ant-slider-handle {
    z-index: 2;
  }
`;

const Checkbox = styled(BaseCheckbox)`
  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: #0bba7a;
    border-color: #0bba7a;
  }

  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #0bba7a !important;
  }
`;

const DayTradeInfoBanner = styled.div`
  width: 100%;
  max-width: 318px;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #f2f1fe;
  border-radius: 4px;
  margin-top: 16px;
  color: #333333;
  font-size: 12px;
  line-height: 16px;
`;

export {
  TabWrapper,
  CustomSelect,
  TriggerPriceSelect,
  AutoBuySubmitButton,
  TabPane,
  Tabs,
  Slider,
  Checkbox,
  DayTradeInfoBanner,
};
